import { useCallback, useState } from 'react'
import type { Notice } from './AuthNotice'

const DEFAULT_ERROR_TITLE = 'Não foi possível continuar'

interface UseAuthNoticeReturn {
  notice: Notice | null
  showError: (message: string, title?: string) => void
  showInfo: (title: string, message: string) => void
  clear: () => void
}

/** Standard hook driving the AuthNotice slot on auth pages. Keeps the same
 *  shape across login, signup, and password-reset so the JSX stays one-liner:
 *  `{notice ? <AuthNotice notice={notice} onClose={clear} /> : null}`. */
export function useAuthNotice(): UseAuthNoticeReturn {
  const [notice, setNotice] = useState<Notice | null>(null)

  const showError = useCallback((message: string, title = DEFAULT_ERROR_TITLE) => {
    setNotice({ kind: 'error', title, message })
  }, [])

  const showInfo = useCallback((title: string, message: string) => {
    setNotice({ kind: 'info', title, message })
  }, [])

  const clear = useCallback(() => {
    setNotice(null)
  }, [])

  return { notice, showError, showInfo, clear }
}
